import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import WorkloadPage from './WorkloadPage';
import FunnelPage from './FunnelPage';
import CourierStatsTab from './CourierStatsTab';
import StockCoveragePage from './StockCoveragePage';
import ProcurementPage from './ProcurementPage';
import AnalyticsV3 from './analytics/AnalyticsV3';

// «Статистика» — только владелец (12.10.2026): дашборды «Сводка / Финансы / Товары / Клиенты /
// Маркетинг» и прежняя статистика на время сверки цифр
const allTabs = [
  { id: 'statistics', label: 'Статистика', ownerOnly: true },
  { id: 'workload', label: 'Нагрузка' },
  { id: 'funnel', label: 'Воронка' },
  { id: 'couriers', label: 'Курьеры' },
  { id: 'coverage', label: 'Покрытие' },
  { id: 'procurement', label: 'Закупка' },
];

function AnalyticsPage({ showToast, onNavigate }) {
  const { user } = useAuth();
  const isOwner = user?.role === 'owner';
  const tabs = allTabs.filter((t) => !t.ownerOnly || isOwner);
  const [activeTab, setActiveTab] = useState(isOwner ? 'statistics' : 'workload');

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Аналитика</h1>
      </div>

      {/* Вкладки — те же .tabs/.tab, что в остальных разделах */}
      <div className="tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Контент */}
      {activeTab === 'statistics' && isOwner && <AnalyticsV3 showToast={showToast} onNavigate={onNavigate} />}
      {activeTab === 'workload' && <WorkloadPage showToast={showToast} />}
      {activeTab === 'funnel' && <FunnelPage showToast={showToast} />}
      {activeTab === 'couriers' && <CourierStatsTab showToast={showToast} />}
      {activeTab === 'coverage' && <StockCoveragePage showToast={showToast} />}
      {activeTab === 'procurement' && <ProcurementPage showToast={showToast} />}
    </div>
  );
}

export default AnalyticsPage;
